import React from 'react';
import styled from 'styled-components';
import { Redirect } from 'react-router-dom';

import Success from './success';

import cross from '../../../assets/cross.svg';
import Button from '../../common/button';

import { spacing, colours, fontSize, borders } from '../../../theme';
import { CONTACT_TITLE } from '../../../constants/titles';

const Form = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: ${spacing.medium} auto;
  padding: 0 ${spacing.small};
  max-width: 25em;
`;

const Select = styled.select`
  flex-direction: column;
  font-family: Montserrat;
  border: none;
  border-bottom: ${borders.dashed};
  background: none
  appearance: none;
  cursor: pointer;
  font-size: ${fontSize.small};
  margin: 0 ${spacing.tiny};
  width: 100%;
`;

const SelectContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: no-wrap;
  white-space: nowrap;
`;

const SelectLine = styled.div`
  display: flex;
  margin: ${spacing.small} 0;
`;

const Option = styled.option`
  background-color: ${colours.yellow};
  :disabled {
    display: none;
  }
`;

const SelectLabel = styled.label`
  margin: 0;
  font-size: ${fontSize.small};
`;

const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: ${spacing.small} 0;
`;

const InputLabel = styled.label`
  font-size: ${fontSize.small};
`;

const Input = styled.input`
  background-color: ${colours.transparentGrey};
  border: ${borders.dashed};
  font-size: ${fontSize.small};
  padding: ${spacing.tiny} 0;
  width: 100%;
`;

const TextArea = styled.textarea`
  background-color: ${colours.transparentGrey};
  border: ${borders.dashed};
  font-size: ${fontSize.small};
  padding: ${spacing.tiny} 0;
  width: 100%;
  height: 6em;
  resize: vertical;
`;

const CheckContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  margin: ${spacing.tiny} 0;
`;

const Checkbox = styled.input`
  appearance: none;
  border: ${borders.black};
  background-color: ${colours.transparentGrey};
  width: ${spacing.small};
  height: ${spacing.small};

  :active,
  :checked {
    background-image: url(${cross});
    background-position: center;
    background-repeat: no-repeat;
  }
`;

const StyledButton = styled(Button)`
  margin-right: 0;
`;

const Contact = ({ setTitle }) => {
  const [redirect, setRedirect] = React.useState(false);
  const [person, setPerson] = React.useState(' ');
  const [name, setName] = React.useState('');
  const [email, setEmail] = React.useState('');
  const [message, setMessage] = React.useState('');
  const [checked, setChecked] = React.useState(false);

  setTitle(CONTACT_TITLE);

  const handleSubmit = e => {
    e.preventDefault();
    fetch(`.netlify/functions/email`, {
      method: 'POST',
      body: JSON.stringify({
        person,
        name,
        email,
        message,
        checked
      }),
      headers: {
        'content-type': 'application/json'
      }
    })
      .then(result => result.json())
      .then(json => {
        if (json.success === true) {
          setRedirect(true);
        }
      })
      .catch(error => console.log(error));
  };

  return (
    <Form onSubmit={handleSubmit}>
      <SelectContainer>
        <SelectLine>
          <SelectLabel htmlFor="who">I am</SelectLabel>
          <Select
            onChange={event => setPerson(event.target.value)}
            value={person}
            id="who"
            required
          >
            <Option disabled defaultValue value=" " />
            <Option value="looking for a job">looking for a job</Option>
            <Option value="an employer">an employer</Option>
            <Option value="interested in your mission">
              interested in your mission
            </Option>
          </Select>
        </SelectLine>
      </SelectContainer>
      <InputContainer>
        <InputLabel>Name</InputLabel>
        <Input
          onChange={event => setName(event.target.value)}
          value={name}
          type="text"
          required
        />
      </InputContainer>
      <InputContainer>
        <InputLabel>Email</InputLabel>
        <Input
          onChange={event => setEmail(event.target.value)}
          value={email}
          type="email"
          required
        />
      </InputContainer>
      <InputContainer>
        <InputLabel>Message</InputLabel>
        <TextArea
          onChange={event => setMessage(event.target.value)}
          value={message}
          type="text"
          required
        />
      </InputContainer>
      <CheckContainer>
        <InputLabel>Send a copy to myself</InputLabel>
        <Checkbox
          onChange={event => setChecked(event.target.checked)}
          checked={checked}
          type="checkbox"
        />
      </CheckContainer>
      <CheckContainer>
        <StyledButton type="submit" label="send" />
      </CheckContainer>
      {redirect && <Redirect to="/contact/success" />}
    </Form>
  );
};

export { Contact, Success };
